import React, { useMemo, useState } from 'react';

import { Button } from '@bringg/react-components';
import { useRoutesMonitoringTranslations } from '@bringg-frontend/monitoring-shared';

import useRouteMonitoringStore from '../../../stores/helpers/use-route-monitoring-store';
import { useStores } from 'bringg-web/recipes';
import { assignDriverValidator } from 'bringg-web/services/tasks/assign-driver-validator';
import UserAssignerTool from 'bringg-web/features/monitoring/shared/components/user-assigner-tool';
import { DetailedCellProps } from '../../hooks/use-columns';
import { getRouteTasks } from '../../../utils/route-utils';

import styles from './driver-cell.module.scss';

const DriverCell = ({ row }: DetailedCellProps) => {
	const { driversStore, runStore } = useStores();

	const route = runStore.get(row.data.id);
	const { driverUnassigned } = useRoutesMonitoringTranslations();
	const [userAssignerModalState, setUserAssignerModalState] = useState<boolean>(false);

	const {
		routesMonitoringStore,
		routeMonitoringActionsStore: { allowAssignDriverToTask }
	} = useRouteMonitoringStore();

	const isRouteCompleted = !!route?.ended_at;
	const driverName = (route?.user_id && driversStore.get(route.user_id)?.name) || driverUnassigned;

	const isDisabled = useMemo(() => {
		if (isRouteCompleted) return true;
		const routeTasks = route ? getRouteTasks(route.id) : [];

		const assignDriverValidation = assignDriverValidator.isAllowedToAssignSelectedTasks(
			routeTasks,
			allowAssignDriverToTask
		);

		return !assignDriverValidation.canAssign || !assignDriverValidation.assignableTasks.length;
	}, [isRouteCompleted, allowAssignDriverToTask, row.data.id, routesMonitoringStore.loading]);

	if (!route) {
		return null;
	}

	if (isRouteCompleted) {
		return <>{driverName}</>;
	}

	return (
		<div className={styles.driverCell}>
			{userAssignerModalState && (
				<UserAssignerTool routeId={row.data.id} closeModal={() => setUserAssignerModalState(false)} />
			)}
			<Button
				type="link"
				onClick={async () => {
					await driversStore.fetchByTeam(route.team_id);
					setUserAssignerModalState(true);
				}}
				className={styles.driverButton}
				disabled={isDisabled}
			>
				{driverName}
			</Button>
		</div>
	);
};

export default DriverCell;
